import { Injectable, EventEmitter } from '@angular/core';
import { AngularFireDatabase, AngularFireAction, DatabaseSnapshot, AngularFireList } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { DatePipe } from '@angular/common';
import { isNull } from 'util';

import { RawRecording, Recording, RecordingCl } from '../data-models/recording.typings';


@Injectable()
export class RecordingsService {
  private db: AngularFireList<RawRecording>;
  private snapshotDB: Observable<AngularFireAction<DatabaseSnapshot>[]>;

  private rawData: RawRecording[];
  public recordings = new Subject<Recording[]>();
  public lastSortedrecordings: RecordingCl[];
  private pureLastDataIncome: RecordingCl[];
  public updateCucles = 0;

  constructor(
    private afdb: AngularFireDatabase,
    private datePipe: DatePipe,
  ) { }

  setUserId(id: string) {
    this.db = this.afdb.list<Recording>(`/recordings/` + id);

    this.db.snapshotChanges().subscribe((recordings: AngularFireAction<DatabaseSnapshot>[]) => {
      const income = recordings.map(rec => new RecordingCl(rec.payload.val(), rec.key));

      this.pureLastDataIncome = [...income];
      this.updateCucles++;
      this.rawData = recordings.map(rec => rec.payload.val());
      this.recordings.next(income);
      // console.log('Proccessed recordings:', this.data);
    });
  }


  changeTitle(newTitle: string, recording: Recording) {
    const rawRecording = this.rawData.find(rec => rec.recordingId === recording.recordingId);

    rawRecording.title = newTitle;
    this.db.update(recording.appInfo.dbKey, rawRecording);
  }


  changeComment(newComment: string, recording: Recording) {
    const rawRecording = this.rawData.find(rec => rec.recordingId === recording.recordingId);

    rawRecording.transcript = newComment;
    this.db.update(recording.appInfo.dbKey, rawRecording);
  }


  markAsPlayed(recording: Recording) {
    const rawRecording = this.rawData.find(rec => rec.recordingId === recording.recordingId);

    rawRecording.isPlayed = true;
    this.db.update(recording.appInfo.dbKey, rawRecording);
  }


  delete(recording: Recording) {
    this.db.remove(recording.appInfo.dbKey);
  }


  deleteSelected(recordS: Recording[]) {
    recordS.forEach(recording => {
      this.delete(recording);
    });
  }

  download(recording: Recording) {
    // window.open(`https://supercallrecorderapp.com/nexmo/download_recording.php?uuid=${recording.recordingId}&url=${recording.recordingUrl}`);
  }

  getDownloadUrl(recording: Recording): string {
    let resp: string;

    if (recording.recordingUrl.includes('download_recording.php')) {
      resp = recording.recordingUrl;
    } else {
      resp = `https://supercallrecorderapp.com/nexmo/download_recording.php?uuid=${recording.recordingId}&url=${recording.recordingUrl}`;
    }

    return resp;
  }

  getPureLastDataIncome(): RecordingCl[] {
    return [...this.pureLastDataIncome];
  }

  // =============== TESTER ===============
  push() {
    this.db.push(this.generateRecording());
  }

  generateRecording(): Recording {
    const durationSec = this.randomiser(7200, 20);
    const date = new Date().getTime();
    const startDate = new Date(this.randomiser(date - date / 1.2, date * 1.2));
    const endDate = new Date(startDate.getTime() + durationSec * 1000);

    let id = '';
    for (let i = 0; i < 15; i++) {
      id += this.randomiser(10);
    }

    const names = ['Axari', 'Landi', 'Recli', 'Hazy', 'Ilari', 'Verdy', 'Ugwe', 'Kansy', 'Puvi', 'Mazini', 'Ganzi', 'Quaxi'];
    const title = names[this.randomiser(names.length - 1)];
    let comment = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < this.randomiser(40, 5); i++) {
      comment += possible.charAt(this.randomiser(possible.length));
    }


    const randomRecording = {
      backupIdentifiers: {
        iCloudFileIdentifier: 'indetiff'
      },
      billDuration: this.randomiser(1000, 100),
      callUUID: 'UUID',
      durationInMS: durationSec * 1000,
      durationInSeconds: durationSec,
      endTime: '',
      from: 'from',
      hangupCause: 'hangup',
      isPlayed: false,
      isRead: false,
      pricePerMinute: Math.random() * (100 - 10) + 10,
      recordingId: id,
      recordingUrl: 'https://s3.amazonaws.com/recordings_2013/d4f55956-42fe-11e8-aec2-02f6f257685a.mp3',
      service: 'service',
      startTime: '',
      status: 'recorded',
      timestamp: new Date().getTime() / 1000000,
      title: title,
      to: 'to',
      totalCost: this.randomiser(1000, 100),
      transcript: comment,

    };

    return new RecordingCl(randomRecording, '0000000');
  }

  randomiser(max: number, min = 0): number {
    return Math.floor(Math.random() * (max - min) + min);
  }
}

// 'https://s3.amazonaws.com/recordings_2013/d4f55956-42fe-11e8-aec2-02f6f257685a.mp3'



// WEBPACK FOOTER //
// ./src/app/services/recordings.service.ts